import { CreateProductForm } from '../../features/CreateProductForm';

const CreateProductPage = () => {
  return <CreateProductForm />;
};

export default CreateProductPage;
